export default "__VITE_ASSET__Ct2jEw0I__"